import axios from '@axios'

const PREFIX = '/departamentos'

export default {

  getDepartamentos(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getDepartamento(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateDepartamento(id, depart) {
    return axios.put(`${PREFIX}/${id}`, depart)
  },

  createDepartamento(depart) {
    return axios.post(`${PREFIX}/add`, depart)
  },

  deleteDepartamento(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getDepartamentosFiltrados(nome) {
    return axios.get(`${PREFIX}/resumidos?nome=${nome}`)
  },

  getResponsaveis(usuarioId, empresaId) {
    return axios.get(`${PREFIX}/responsaveis/${usuarioId}/${empresaId}`)
  },
}
